import styled from 'styled-components';
import { Menu } from '@/ui';
import { COLORS, pickThemeFontStyles } from '@/theme';

export const StyledMenu = styled(Menu)`
  width: 100%;
`;

export const StyledMainTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 2rem;
  padding-bottom: 0;
  align-items: start;
  background-color: ${COLORS.GRAY_LIGHT};
  border-bottom: 1px solid ${COLORS.GREY};
`;

export const StyledPageTitle = styled.div`
  ${pickThemeFontStyles('24', '30', 'SEMI_BOLD')};
  color: ${COLORS.BLACK};
`;
